import React, { useContext } from "react";
import "./DashboardNavbar.scss";
import logo from "../../logo.png";
import { Link, useHistory } from "react-router-dom";
import AuthContext from "../../Store/auth-context";
import axios from "axios";

function DashboardNavbar() {
  const { logout } = useContext(AuthContext);
  const history = useHistory();
  const mail = localStorage.getItem("email");

  const SignOut = () => {
    logout();
    history.replace("/");
  };
  const ManageBilling = async () => {
    // try {
    //   fetch(
    //     "https://stripe-node-vx6pg.ondigitalocean.app/create-customer-portal-session",
    //     {
    //       crossDomain: true,
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Accept: "application/json",
    //       },
    //       body: { email: mail },
    //     }
    //   )
    //     .then((res) => (window.location.href = res.data));
    // } catch (e) {
    //   console.log(e);
    // }

    await axios.post("https://stripe-node-vx6pg.ondigitalocean.app/create-customer-portal-session", {
      // await axios
      //   .post("http://localhost:8000/create-customer-portal-session", {
      email: mail,
    })
      .then((res) => (window.location.href = res.data));
  };
  return (
    <div id="DashboardNavbar">
      <nav className="navbar navbar-expand-md navbar-dark bg-custom fixed-top">
        <div className="container-fluid navbarWidth">
          <Link to="/">
            <img className="navlogo" src={logo} alt="logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav ms-auto pe-3 mt-1 mb-md-0">
              <li className="nav-item ms-md-2">
                <button
                  type={"button"}
                  className="nav-link manage"
                  onClick={ManageBilling}
                >
                  Manage billing
                </button>
              </li>
            </ul>
            <button className="btn joinButton text-nowrap" onClick={SignOut}>
              Sign Out
            </button>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default DashboardNavbar;
